import store from '../store/index';

export default async function ({ next }) {
  const userAuthToken = window.arcux.token;
  const request = `${process.env.VUE_APP_SITE}/api/v1/me`;

  if (!userAuthToken) {
    store.dispatch('updateUserLoading', false);

    return next();
  }

  if (store.getters.userData && store.getters.userData.email) {
    store.dispatch('updateUserLoading', false);

    return next();
  }

  const responseObject = await fetch(request, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${userAuthToken}`,
    },
  });

  if (responseObject.status === 200 || responseObject.status < 300) {
    const response = await responseObject.json();

    if (response.status) {
      const userRoles = !Array.isArray(response.data.roles)
        ? Object.values(response.data.roles)
        : response.data.roles;

      store.dispatch('updateUserData', {
        userData: {
          ...response.data,
          roles: userRoles,
        },
      });
      store.dispatch('updateUserLoading', false);

      return next();
    }
  }

  store.dispatch('updateUserLoading', false);

  return next();
}
